import { CLEAR_SUGGESTIONS } from '../actions/mentions'

const mapById = list =>
  list.reduce((r, p) => {
    r[p._id || p.id] = p
    return r
  }, {})

const draft = (state = {}, action = {}) => {
  switch (action.type) {
    case CLEAR_SUGGESTIONS:
      if (action.payload) {
        const { values, range } = action.payload
        state = {
          map: Object.assign({}, mapById(values)),
          list: {
            loading: false,
            values: values.map(p => p._id || p.id), // just list the id's
            range: range
          }
        }
      } else {
        state = {}
      }
      break
  }
  return state
}

export default draft
